export default __webpack_public_path__ + "static/media/multiple_gift.2f1ecc78.svg";